import { createContext, useContext, useEffect, useState } from 'react';
import { getAppConfigs } from 'clients/ConfigClient';
import { isValid } from 'clients/Clients';
import { EnumAppCode } from 'constants/Enums/app-settings';
import { isJsonString } from 'utils/helper';

const SettingContext = createContext({});

export const SettingProvider = ({ children }) => {
  // App configs
  const [configs, setConfigs] = useState({});
  // Đã gọi xong app-value (thành công hay lỗi), để trang cần config biết lúc nào được dùng giá trị mặc định
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);

  useEffect(() => {
    getConfigs();
  }, []);

  const getConfigs = async () => {
    try {
      const res = await getAppConfigs({ ctx: undefined, appCode: EnumAppCode.WEB_THUOCSI });
      if (isValid(res)) {
        const config = res.data;
        const parseConfig = Object.entries(config).reduce((acc, [_, configItem]) => {
          if (configItem && configItem.value) {
            const { key, object } = configItem.value;

            if (key) {
              let parseObject = object;
              if (typeof object === 'string' && isJsonString(object)) {
                try {
                  parseObject = JSON.parse(object);
                } catch (error) {
                  console.error(`Error parsing JSON for key "${key}":`, error);
                  parseObject = object;
                }
              }

              acc[key] = parseObject;
            }
          }
          return acc;
        }, {});

        setConfigs(parseConfig);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsConfigLoaded(true);
    }
  }

  return (
    <SettingContext.Provider
      value={{
        configs,
        isConfigLoaded,
      }}
    >
      {children}
    </SettingContext.Provider>
  );
};

export const useSetting = () => useContext(SettingContext);
